export const PH_ISD_CODE = '+63';
export const PH_MOBILE_NUMBER_LENGTH = 10;
export const ISD_CODE_LENGTH = 3;
export const PERMISSION_VOID_REFUND_MAXIMUM = 3;
